import { useRef, useEffect } from 'react';

import { useAlert } from 'hooks';
import { parseAxiosError } from 'utils/error';

interface HandleQueryProps {
  error?: unknown;
}

export const useHandleQuery = ({ error }: HandleQueryProps) => {
  const { showErrorAlert } = useAlert();
  const prevErrorMessageRef = useRef<string | null>(null);

  useEffect(() => {
    if (error) {
      const message = parseAxiosError(error);

      if (message !== prevErrorMessageRef.current) {
        prevErrorMessageRef.current = message;
        showErrorAlert(message);
      }
    } else {
      prevErrorMessageRef.current = null;
    }
  }, [error, showErrorAlert]);
};
